export default __webpack_public_path__ + "static/media/laporan-absensi.241aa700.png";